var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReportFormSteps',{attrs:{"sfc_code":_vm.$route.query.company_id,"annual_report":_vm.$route.query.annual_report}})}
var staticRenderFns = []

export { render, staticRenderFns }